import api from './api';

function unwrap(response, fallback) {
  const body = response?.data || {};
  if (body.error || body.code !== 200) {
    const error = new Error(body.message || fallback);
    error.backend = body;
    throw error;
  }
  return body.dataset?.data;
}

export async function fetchCoinPaymentGateways(couponCode = '') {
  const response = await api.get('/payment/get-payment-gateway', {
    params: { platform: 'web', ...(couponCode ? { coupon_code: couponCode } : {}) },
  });
  const data = unwrap(response, 'Unable to load payment methods.');
  return Array.isArray(data) ? data : [];
}

export const fetchPaymentGateways = fetchCoinPaymentGateways;

export async function createCoinOrder(pack) {
  if (!Number.isFinite(Number(pack?.coins)) || Number(pack.coins) <= 0 ||
      !Number.isFinite(Number(pack?.discountedPrice)) || Number(pack.discountedPrice) <= 0) {
    throw new Error('Select a valid coin pack.');
  }
  const response = await api.post('/subscription/generate-order', {
    order_type: 'purchase-gamification-coins',
    coin_amount: Number(pack.coins),
    amount: String(pack.discountedPrice),
  });
  const data = unwrap(response, 'Unable to create coin order.');
  if (!data?.vk_order_id) throw new Error('The server did not return an order ID.');
  return data;
}

export async function fetchCoinOrderAmounts(orderId) {
  const response = await api.get('/subscription/order-amounts', { params: { vk_order_id: orderId } });
  return unwrap(response, 'Unable to refresh order amount.') || {};
}

export async function fetchAvailableCoins() {
  const response = await api.get('/coins/available');
  return unwrap(response, 'Unable to load available coins.') || {};
}

async function changeOrder(path, payload) {
  const response = await api.post(path, payload);
  return unwrap(response, 'Unable to update order.') || {};
}

export const applyCoinCoupon = (orderId, couponCode) =>
  changeOrder('/subscription/apply-coupon', { vk_order_id: orderId, coupon_code: couponCode });
export const removeCoinCoupon = (orderId) =>
  changeOrder('/subscription/remove-coupon', { vk_order_id: orderId });
export const applyExistingCoins = (orderId, coins) =>
  changeOrder('/subscription/apply-coins', { vk_order_id: orderId, coins: String(coins) });
export const removeExistingCoins = (orderId) =>
  changeOrder('/subscription/remove-coins', { vk_order_id: orderId });

export async function createRazorpayCoinOrder(orderId, gatewayId) {
  const response = await api.post('/razorpay/create-order', {
    vk_order_id: orderId,
    payment_gateway_id: gatewayId,
  });
  const data = unwrap(response, 'Unable to start Razorpay checkout.');
  if (!data?.razorpay_order_id) throw new Error('The server did not return a Razorpay order ID.');
  return data;
}

export const createRazorpayOrder = createRazorpayCoinOrder;

export async function updateManualCoinOrder(orderId, gatewayId) {
  return changeOrder('/subscription/update-order', {
    vk_order_id: orderId,
    payment_gateway_id: String(gatewayId),
  });
}

export const updateManualPaymentOrder = updateManualCoinOrder;

export async function fetchCoinOrderDetail(orderId) {
  const response = await api.get('/subscription/order-detail', { params: { vk_order_id: orderId } });
  return unwrap(response, 'Unable to check payment status.') || {};
}
